<template>
  <el-dialog :append-to-body="true" :before-close="close" :close-on-click-modal="false" :visible.sync="dialog" title="修改密码" width="400px">
    <el-form ref="form" :model="form" :rules="rules">
        <el-form-item label="旧密码" prop="old_pwd">
            <el-input v-model="form.old_pwd" placeholder="输入旧密码"></el-input>
        </el-form-item>
        <el-form-item label="新密码" prop="new_pwd">
            <el-input v-model="form.new_pwd" placeholder="输入新密码"></el-input>
        </el-form-item>
        <el-form-item>
            <el-button :loading="loading" style="width:100%" type="primary" @click="changePwd">确定</el-button>
        </el-form-item>
    </el-form>
  </el-dialog>
</template>

<script>
import {change_pass} from '@/api'

export default {
    data(){
        return{
            dialog: false,
            form:{
                old_pwd: '',
                new_pwd: '',
            },
            rules: {
                old_pwd: [
                    {required: true, message: '请输入旧密码',trigger: 'blur'}
                ],
                new_pwd: [
                    {required: true, message: '请输入新密码',trigger: 'blur'}
                ]
            },
            loading: false,
        }
    },
    methods:{
        open(){
            this.dialog = true
        },
        close(){
            this.form = {
                old_pwd: '',
                new_pwd: '',
            }
            this.dialog = false
        },
        changePwd(){
            this.$refs.form.validate(valid => {
                if(valid){
                    this.loading = true
                    let req = {
                        old_pwd: this.form.old_pwd,
                        new_pwd: this.form.new_pwd,
                    }
                    change_pass(req).then(res => {
                        this.loading = false
                        this.$message.success(res.msg)
                        this.close()
                    }).catch(err => {
                        this.loading = false
                    })
                }
            })
        }
    }
}
</script>

<style>

</style>
